<template>
  <div @wheel="onWheel">
    <v-breadcrumbs :items="breadCrumbItems" divider=">"> </v-breadcrumbs>
    <v-layout justify-space-between wrap>
      <TenderDetailGeneralInformBlock
        :tender="tender"
        :getTender="getTender"
        :type="type"
        :openInformationDetail="openInformationDetail"
        :categoryDescription="categoryDescription"
        :style="{
          position: leftBlockFixed ? 'fixed' : '',
          top: '85px',
          width: leftBlockFixed ? '33%' : '',
        }"
        ref="leftBlock"
      />

      <v-flex
        xs12
        md8
        class="mt0 right-box lr-6 pt-0 pl-0 pr-8 pt-0 pl-lg-2 right-box-responsive"
        v-if="!isSubmitTenderShown"
        :offset-md-4="leftBlockFixed"
        :offset-lg-4="leftBlockFixed"
        ref="rightBlock"
      >
        <TenderDetailFieldsBlock
          v-if="!openAccordion"
          :openInformationDetail="openInformationDetail"
          :tender="tender"
          :type="type"
          :getTender="getTender"
        />

        <v-layout v-else class="pl-lg-2 mb-4">
          <router-view
            name="field"
            :tender="tender"
            :closeField="closeField"
            :type="type"
            :getTender="getTender"
          ></router-view>
        </v-layout>
      </v-flex>
      <v-flex xs12 lg8 class="mt0 right-box lr-6 pt-0 pl-8 pr-8 pt-0">
        <router-view name="submit"></router-view>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import TenderDetailFieldsBlock from '@/components/app/tenders/tenderDetail/TenderDetailFieldsBlock'
import TenderDetailGeneralInformBlock from '@/components/app/tenders/tenderDetail/TenderDetailGeneralInformBlock'
import GlobalFunctions from '@/utils/GlobalFunctions'
import Vue from 'vue'
import subscriptions from '@/services/apiCalls/subscriptions'

export default {
  props: {
    tender: {
      type: null,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    getTender: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      openAccordion: false,
      isSubmitTenderShown: false,
      leftBlockFixed: false,
    }
  },

  components: {
    TenderDetailFieldsBlock,
    TenderDetailGeneralInformBlock,
  },

  watch: {
    $route(newValue) {
      if (newValue.path.split('/').length === 3) {
        this.openAccordion = false
      } else {
        this.openAccordion = this.$route.params.fieldId
      }
      if (newValue.path.includes('submit_tender')) {
        this.isSubmitTenderShown = true
      }
    },
    tender: {
      handler(v) {
        if (v) {
          this.subscribeOnTenderChanges();
        }
      },
      immediate: true,
    }
  },

  created() {
    this.$gettext('Submission Method')
    this.$gettext('Procurement Method')
    this.$gettext('Procurement Method Type')
    this.$gettext('Scheme')
    this.$gettext('Telephone')
    this.$gettext('Name')
    this.$gettext('Title')
    this.$gettext('Size')
    this.$gettext('Language')
    this.$gettext('Classification')
    this.$gettext('Delivery Start')
    this.$gettext('Delivery End')
    this.$gettext('Start typing')
    this.$gettext('Unit')
    this.$gettext('documents')
    this.$gettext('document')

    this.handleFieldPresence()
    this.$store.commit('setSideBarPermanentState', true)
  },

  destroyed() {
    this.$store.commit('setSideBarPermanentState', false)
  },

  computed: {
    setBreadcrumbTag() {
      return this.openAccordion ? 'a' : ''
    },
    breadCrumbItems() {
      if (!this.tender) return []
      let breadCrumbItems = [
        {
          text:
            this.type === 'myTenders'
              ? 'My Tenders'
              : this.type === 'prozorroTenders'
              ? 'Prozorro Tenders'
              : this.type === 'myBidsTender'
              ? 'My Bids Tenders'
              : this.type === 'myDraftBidsTender'
              ? 'My Draft Bids Tenders'
              : 'Tenders',
          disabled: false,
          to: { path: this.mainPath },
          exact: true,
        },
        {
          text: this.breadcrumbTenderTitle,
          disabled: !this.openAccordion ? true : false,
          to: { path: `${this.mainPath}/${this.$route.params.id}` },
          exact: true,
        },
        {
          text: this.openAccordion,
          disabled: true,
        },
      ]

      if (this.openAccordion) {
        return breadCrumbItems
      } else {
        return breadCrumbItems.slice(0, 2)
      }
    },
    tenderPeriod() {
      if (this.tender && this.tender.tenderPeriod) {
        return Vue.moment(this.tender.tenderPeriod.endDate).format('ll')
      }

      return ''
    },
    breadcrumbTenderTitle() {
      if (this.openAccordion && this.tender) {
        return this.substringText(this.tender.title, 100)
      } else if (this.tender) {
        return this.tender.title
      }
      return ''
    },
    categoryDescription() {
      if (this.tender) {
        const category =
          this.type === 'prozorroTenders'
            ? this.tender.items[0].classification.id
            : this.tender.category
        return `${
          this.$store.state.i18n.translations[this.$store.state.i18n.locale][`cpv.${category}`]
        } (${category})`
      } else {
        return ''
      }
    },
    formattedStatus() {
      return this.tender.status
    },
    mainPath() {
      return this.type === 'myTenders'
        ? '/my-tenders'
        : this.type === 'prozorroTenders'
        ? '/prozorro-tenders'
        : this.type === 'myBidsTender'
        ? '/my-bids-tenders'
        : this.type === 'myDraftBidsTender'
        ? '/my-draft-bids-tenders'
        : '/tenders'
    },
  },

  methods: {
    subscribeOnTenderChanges() {
      if (this.tender.mpID) {
        const subscription = subscriptions.onTenderChanged(this.tender.mpID).subscribe({
          next: ({ status }) => {
            this.tender.status = status;
          },
          error: error => console.error(error),
        });
        this.$once('hook:beforeDestroy', () => {
          subscription.unsubscribe();
        })
      }
    },

    onWheel() {
      // const rightBlockTop = this.$refs.rightBlock.getBoundingClientRect()
      //     .rightBlockTop
      const rightBlockTop = this.$refs.rightBlock.getBoundingClientRect().top
      const leftBlockHeight = document.getElementById('inform-block-card').offsetHeight

      this.leftBlockFixed =
        rightBlockTop < -5 &&
        leftBlockHeight < window.outerHeight &&
        this.$vuetify.breakpoint.mdAndUp
    },
    handleFieldPresence() {
      if (this.$route.params.fieldId) {
        this.openAccordion = this.$route.params.fieldId
      }
    },
    closeField() {
      this.$router.push({
        path: `${this.mainPath}/${this.$route.params.id}`,
      })
    },
    openInformationDetail(section) {
      this.openAccordion = section

      this.$router.push({
        path: `${this.mainPath}/${this.$route.params.id}/${section}`,
      })
    },
    substringText(text, length) {
      return GlobalFunctions.substring(text, length)
    },
    onResize() {
      window.innerWidth < 961 && this.$store.commit('setSideBarPermanentState', false)

      window.innerWidth > 960 && this.$store.commit('setSideBarPermanentState', true)
    },
  },
}
</script>

<style lang="scss" scoped>
.v-breadcrumbs {
  padding-right: 2rem !important;
  flex-wrap: nowrap;
}

.tender-breadcrumb {
  overflow: hidden;
}
/* .right-box-responsive {
    @media screen and (min-width: 960px) and (max-width: 1070px) {
        padding-left: 3rem !important;
    }
    @media screen and (min-width: 1180px) and (max-width: 1264px) {
        padding-left: -4rem !important;
    }
} */
</style>
